<app-loader [size]="30" [opacity]="'0.7'" [center]="true" *ngIf="wellnessMenuFile === null"></app-loader>

<ng-container *ngIf="wellnessMenuFile?.value">
  <a [href]="wellnessMenuFile?.value|apiUrl" target="_blank" class="btn btn-bordered" [class]="btnClass">{{ text | translate }}</a>
</ng-container>
<ng-container *ngIf="wellnessMenuFile !== null && !wellnessMenuFile?.value">
  <span class="small">{{ 'menu_is_currently_unavailable'|translate }}</span>
</ng-container>
